import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

const INITIAL_STATE = {};

@Injectable({
  providedIn: 'root'
})
export class StateService {

    private _state = new BehaviorSubject(INITIAL_STATE);

    state = this._state.asObservable();
    
    getGlobal(key:any){
      if(key === undefined){
        return this._state.getValue();
      };
      let state = this._state.getValue();
      return state[key];
    }

    setGlobal(key:string, value){
      let state = this._state.getValue();
      state[key] = value;
      this._state.next(state);
    }
    
    removeGlobal(key:string){
      let state = this._state.getValue();
      delete state[key];
      this._state.next(state);
    }
}